import React from "react";
import { useParams } from "react-router";
import Footer from "../component/Footer";
import Query from "../component/Query/index";
import APPLICATION_QUERY from "../queries/applications";
const Application = () => {
  let { slug } = useParams();
  return (
    <div>
      <Query query={APPLICATION_QUERY} slug={slug}>
        {({ data: { applications } }) => {
          if (applications.length) {
            const banner = applications[0].banner.url;
            const imageOne = applications[0].image_one.url;
            const imageThree = applications[0].image_three.url;
            const imageFour = applications[0].image_four.url;
            const imageFive = applications[0].image_five.url;
            const imageTwo = applications[0].image_two.url;
            return (
              <div>
                <main className="font-nunito">
                  <section className="pt-16">
                    <div className="flex justify-center items-center w-full relative">
                      <picture class="jumbotron-picture ">
                        <source
                          className="w-full max-h-max"
                          media="(max-width: 767px)"
                          srcset={banner}
                        />
                        <source
                          className="w-full max-h-max"
                          media="(min-width: 768px)"
                          srcset={banner}
                        />
                        <img
                          className="w-full max-h-max"
                          src={banner}
                          alt="Responsive jumbotron Image"
                        />
                      </picture>
                      <div
                        className="w-full
                      flex flex-col m-auto justify-center items-center absolute top-0 bottom-0 overflow-y-hidden"
                      >
                        <h1 className="text-white text-2xl md:text-5xl text-center font-secular leading-relaxed">
                          {applications[0].banner_title}
                        </h1>
                        <p className="text-center text-white text-lg">
                          {applications[0].banner_description}
                        </p>
                      </div>
                    </div>
                  </section>
                  {/* Jumbotron Section End Here */}
                  <section>
                    <h2 className="text-black uppercase text-3xl lg:text-4xl pt-6 md:pt-11 font-bold text-center">
                      {applications[0].title_2}
                    </h2>

                    <div className="lg:px-56 px-6 py-10 flex flex-col justify-center items-center">
                      <p className="text-justify font-poppins">
                        {applications[0].content_2}
                      </p>
                      <button className="text-white bg-main-color mt-5 p-3 pl-11 pr-11 mb-5 rounded-md transition .ease-in duration-1000ms hover:bg-orange-dark">
                        <a href="#">Register For Free</a>
                      </button>
                    </div>
                  </section>

                  <section>
                    <div className="w-full">
                      <div className="flex flex-col lg:flex-row justify-around lg:px-16 px-6 py-16">
                        <div className="lg:w-3/6 flex justify-center shadow-xl">
                          <img className="rounded-lg" src={imageOne} alt="" />
                        </div>
                        <div className="lg:w-3/6 lg:ml-5 flex flex-col justify-center items-center">
                          <h2 className="text-black text-xl mt-5 lg:mt-0 lg:text-2xl font-bold text-center mb-5 ">
                            {applications[0].title_one}
                          </h2>
                          <p className="font-poppins text-justify text-desc-text">
                            {applications[0].description_one}
                          </p>
                        </div>
                      </div>
                      <div className="flex flex-col lg:flex-row justify-around mt-16 bg-gray-100 px-6 py-16 lg:px-16">
                        <div className="lg:w-3/6 flex justify-center shadow-xl lg:order-2">
                          <img className="rounded-lg" src={imageTwo} alt="" />
                        </div>
                        <div className="lg:w-3/6 lg:mr-5 flex flex-col justify-center items-center lg:order-1">
                          <h2 className="text-black text-xl mt-5 lg:mt-0 lg:text-2xl font-bold text-center mb-5 ">
                            {applications[0].title_two}
                          </h2>
                          <p className="font-poppins text-justify text-desc-text">
                            {applications[0].description_two}
                          </p>
                        </div>
                      </div>
                      <div className="flex flex-col lg:flex-row justify-around mt-16 px-6 py-16 lg:px-16">
                        <div className="lg:w-3/6 flex justify-center shadow-xl">
                          <img className="rounded-lg" src={imageThree} alt="" />
                        </div>
                        <div className="lg:w-3/6 lg:ml-5 flex flex-col justify-center items-center">
                          <h2 className="text-black text-xl mt-5 lg:mt-0 lg:text-2xl font-bold text-center mb-5 ">
                            {applications[0].title_three}
                          </h2>
                          <p className="font-poppins text-justify text-desc-text">
                            {applications[0].description_three}
                          </p>
                        </div>
                      </div>
                      <div className="flex flex-col lg:flex-row justify-around mt-16 bg-gray-100 px-6 py-16 lg:px-16">
                        <div className="lg:w-3/6 flex justify-center shadow-xl lg:order-2">
                          <img className="rounded-lg" src={imageFour} alt="" />
                        </div>
                        <div className="lg:w-3/6 lg:mr-5 flex flex-col justify-center items-center lg:order-1">
                          <h2 className="text-black text-xl mt-5 lg:mt-0 lg:text-2xl font-bold text-center mb-5 ">
                            {applications[0].title_four}
                          </h2>
                          <p className="font-poppins text-justify text-desc-text">
                            {applications[0].description_four}
                          </p>
                        </div>
                      </div>
                      <div className="flex flex-col lg:flex-row justify-around mt-16 px-6 py-16 lg:px-16">
                        <div className="lg:w-3/6 flex justify-center shadow-xl">
                          <img className="rounded-lg" src={imageFive} alt="" />
                        </div>
                        <div className="lg:w-3/6 lg:ml-5 flex flex-col justify-center items-center">
                          <h2 className="text-black text-xl mt-5 lg:mt-0 lg:text-2xl font-bold text-center mb-5 ">
                            {applications[0].title_five}
                          </h2>
                          <p className="font-poppins text-justify text-desc-text">
                            {applications[0].description_five}
                          </p>
                        </div>
                      </div>
                    </div>
                  </section>

                  {/* 3 easy step Section Start Here */}
                  <section className="mb-9 mt-9">
                    <div className="bg-main-color flex flex-col justify-center items-center p-10">
                      <h1 className="text-white text-xl lg:text-2xl font-bold text-center lg:px-56 mb-5">
                        TRY AND SEE HOW NEOVO SIGNAGE HELPS YOU TO MANAGE YOUR
                        DIGITAL MENU BOARD
                      </h1>

                      <button className="text-main-color font-bold uppercase bg-white p-3 pl-11 pr-11 rounded-md transition .ease-in duration-1000ms hover:text-white hover:bg-orange-dark">
                        <a href="#">Register Now</a>
                      </button>
                    </div>
                    <h2 className="text-black text-3xl lg:text-4xl pt-16 mb-7 font-bold text-center p-3">
                      PRODUCT SELECTION
                    </h2>

                    <div className="solution flex flex-col lg:flex-row justify-center p-4 lg:px-28">
                      <div className="shadow-lg hover:shadow-xl rounded-md lg:w-4/12 p-4 mx-6 mb-9">
                        <div className="flex flex-col items-center">
                          <h3 className="font-robotoslab mb-5 text-xl font-bold text-desc-text text-center">
                            Dont't Have Display?
                          </h3>
                          <img
                            loading="lazy"
                            src="../img/7.png"
                            width="175"
                            className=""
                            alt=""
                          />
                          ​
                        </div>
                        <div className="font-poppins">
                          <p className="text-left">Choose Your Display:</p>
                          <ul className="list-disc pl-6">
                            <li>
                              Any size with Android Operating System, Windows or
                              Tizen​ Landscape and/or portrait display
                              orientation
                            </li>
                            <li>Resolution Full HD or 4K​</li>
                            <li>16/7 or 24 operational hours​​</li>
                            <li>Panelo Sign subscription​​</li>
                          </ul>
                        </div>
                        <div className="flex justify-center items-center">
                          <button className="text-white bg-main-color mt-10 p-3 pl-11 pr-11 mb-5 rounded-md transition .ease-in duration-1000ms hover:bg-orange-dark">
                            <a href="#">Buy Now</a>
                          </button>
                        </div>
                      </div>
                      <div className="shadow-lg hover:shadow-xl rounded-md lg:w-4/12 p-4 mx-6  mb-9">
                        <div className="flex flex-col items-center">
                          <h3 className="font-robotoslab mb-9 text-xl font-bold text-desc-text text-center">
                            Already Have Display?
                          </h3>
                          <img
                            loading="lazy"
                            src="../img/8.png"
                            width="195"
                            className=""
                            alt=""
                          />
                        </div>
                        <div className="font-poppins mt-16">
                          <p className="text-left">Choose Your Media Player:</p>
                          <ul className="list-disc pl-6">
                            <li>Mini PC with Windows 10 OS​</li>
                            <li>Android Box with Android 7 and above​​</li>
                            <li>Single or Videowall mode​​​</li>
                            <li>16/7 or 24 hrs operational hours​​​</li>
                            <li>Panelo Sign subscription​​​</li>
                          </ul>
                        </div>
                        <div className="flex justify-center items-center">
                          <button className="text-white bg-main-color mt-16 p-3 pl-11 pr-11 mb-5 rounded-md transition .ease-in duration-1000ms hover:bg-orange-dark">
                            <a href="#">Buy Now</a>
                          </button>
                        </div>
                      </div>
                      <div className="shadow-lg hover:shadow-xl rounded-md lg:w-4/12 p-4 mx-6  mb-9">
                        <div className="flex flex-col items-center">
                          <h3 className="font-robotoslab mb-5 text-xl font-bold text-desc-text text-center">
                            Need Custom or Enterprise class deployment?​
                          </h3>
                          <img
                            loading="lazy"
                            src="../img/9.png"
                            width="175"
                            className=""
                            alt=""
                          />
                          ​
                        </div>
                        <div className="font-poppins">
                          <p className="text-left">Custom Deployment:</p>
                          <ul className="list-disc pl-6">
                            <li>On-Premise deployment​</li>
                            <li>Custom IoT/Sensor/Application deployment​</li>
                            <li>Kiosk Application​​​</li>
                            <li>OEM or White label​</li>
                          </ul>
                        </div>
                        <div className="flex justify-center items-center">
                          <button className="text-white bg-main-color mt-20  p-3 pl-11 pr-11 mb-5 rounded-md transition .ease-in duration-1000ms hover:bg-orange-dark">
                            <a href="#">Buy Now</a>
                          </button>
                        </div>
                      </div>
                    </div>
                  </section>
                  {/* Hardware Section End Here */}

                  <section className="bg-background-color  bg-gradient-to-r">
                    <div className="flex flex-col justify-center items-center">
                      <h2 className="text-white font-bold text-xl lg:text-3xl  uppercase mt-10 text-center">
                        Contact Us For More Information
                      </h2>
                      <p className="text-white font-poppins text-md lg:text-xl  mb-5 text-center mt-2 p-4">
                        Our Sales Manager will reach you as soon as we can
                      </p>
                      <button className="text-main-color font-bold  bg-white mb-5 p-3 pl-11 pr-11 rounded-md transition .ease-in duration-1000ms hover:text-white hover:bg-orange-dark">
                        <a href="#">Contact Us</a>
                      </button>
                    </div>
                  </section>
                  <section className="bg-gray-100 pb-16">
                    <h2 className="text-heading-color text-3xl lg:text-4xl pt-11 font-bold text-center mb-12">
                      OUR BLOG
                    </h2>
                    <div className="flex flex-col lg:flex-row justify-center items-center">
                      <div className="blog flex flex-col justify-center lg:w-3/12 m-6 bg-white hover:shadow-lg">
                        <img
                          loading="lazy w-full"
                          src="../img/blog-1.png"
                          alt=""
                        />
                        <div className="p-4">
                          <h3 className="font-bold">
                            An Ultimate Digital Signage Solution Guide
                          </h3>
                          <p>
                            Digital signage attracts 400% more views than static
                            signs. In July...
                          </p>
                          <a
                            className="float-right hover:underline hover:text-main-color mb-6 mt-6"
                            href=""
                          >
                            Read More
                          </a>
                        </div>
                      </div>
                      <div className="blog flex flex-col justify-center lg:w-3/12 m-6 bg-white hover:shadow-lg">
                        <img loading="lazy" src="../img/blog-2.png" alt="" />
                        <div className="p-4">
                          <h3 className="font-bold">
                            Choose the Right Digital Signage Software for Retail
                            Business
                          </h3>
                          <p>
                            Brick and mortar retail stores have had challenges
                            competing against the ease...
                          </p>
                          <a
                            className="float-right hover:underline hover:text-main-color mb-6 mt-6"
                            href=""
                          >
                            Read More
                          </a>
                        </div>
                      </div>
                      <div className="blog flex flex-col justify-center lg:w-3/12 m-6 bg-white hover:shadow-lg">
                        <img loading="lazy" src="../img/blog-3.png" alt="" />
                        <div className="p-4">
                          <h3 className="font-bold">
                            Tips: Screen Sharing & Wireless Presentation on
                            Meetboard Interactive
                          </h3>
                          <p>
                            Digital signage attracts 400% more views than static
                            signs. In July...
                          </p>
                          <a
                            className="float-right hover:underline hover:text-main-color mb-6 mt-6"
                            href=""
                          >
                            Read More
                          </a>
                        </div>
                      </div>
                    </div>
                    <a
                      className="hover:text-main-color flex underline flex-col text-center mt-24 text-gray-600"
                      href="/blog"
                    >
                      See More
                    </a>
                  </section>
                </main>
              </div>
            );
          }
        }}
      </Query>
      <Footer />
    </div>
  );
};

export default Application;
